import React, { useState, useEffect } from "react";
import Sidebar from "../../../components/Dashboard/Sidebar/Sidebar";
import Header from "../../../components/Dashboard/Header/Header";
import SummaryCard from "../../../components/Dashboard/SummaryCard/SummaryCard";
import { 
  Calendar, 
  Clock, 
  UserCheck, 
  Clock9, 
  AlertCircle, 
  FileText, 
  Wallet 
} from 'lucide-react';
import Breadcrumbs from '../../../components/Common/Breadcrumbs/Breadcrumbs';
import styles from './EmployeeDashboard.module.css';
import Footer from '../../../components/Common/Footer/Footer';
import api from "../../../api/axios";

const EmployeeDashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({
        total_attendance: 0,
        pending_leaves: 0,
        approved_leaves: 0,
        ot_hours: 0,
        advance_requests: 0,
        pending_tasks: 0
    });

    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const summaryData = [
        {
            icon: <UserCheck size={20} />,
            label: 'Attendance (This Month)',
            value: summary.total_attendance.toString(),
            iconBg: '#10b981'
        },
        {
            icon: <Calendar size={20} />,
            label: 'Pending Leaves',
            value: summary.pending_leaves.toString(),
            iconBg: '#f59e0b'
        },
        {
            icon: <Clock9 size={20} />,
            label: 'OT Hours (MTD)',
            value: summary.ot_hours.toString(),
            iconBg: '#3b82f6'
        },
        {
            icon: <Wallet size={20} />,
            label: 'Advance Requests',
            value: summary.advance_requests.toString(),
            iconBg: '#ef4444'
        },
        {
            icon: <FileText size={20} />,
            label: 'Pending Tasks',
            value: summary.pending_tasks.toString(),
            iconBg: '#6366f1'
        }
    ];

    return (
        <div className={`${styles['dashboard-container']} ${isSidebarOpen ? styles['sidebar-open'] : ''}`}>
            {isSidebarOpen && <div className={styles['sidebar-overlay']} onClick={() => setIsSidebarOpen(false)}></div>}
            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            <div className={styles['content-wrapper']}>
                <Header onMenuClick={toggleSidebar} />
                <main className={styles['main-content']}>
                    <Breadcrumbs customItems={[
                        { label: 'HR', path: '#' },
                        { label: 'Employee Dashboard', path: '/employees/dashboard' }
                    ]} />
                    
                    <div className={styles['dashboard-header-area']}>
                        <div className={styles['welcome-section']}>
                            <h1>Employee Dashboard</h1>
                            <p>Personal overview for {user?.name || 'Employee'}, {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}.</p>
                        </div>
                    </div>

                    <div className={styles['summary-grid']}>
                        {summaryData.map((data, index) => (
                            <SummaryCard key={index} {...data} />
                        ))}
                    </div>

                    <div className={styles['dashboard-grid']}>
                        <div className={styles['dashboard-card']}>
                            <div className={styles['card-header']}>
                                <div className={styles['header-left']}>
                                    <Clock size={20} />
                                    <h2>Recent Attendance</h2>
                                </div>
                                <button className={styles['view-all-btn']}>View All</button>
                            </div>
                            <div className={styles['card-content']}>
                                <p className={styles['empty-text']}>No recent attendance logs found.</p>
                            </div>
                        </div>

                        <div className={styles['dashboard-card']}>
                            <div className={styles['card-header']}>
                                <div className={styles['header-left']}>
                                    <Calendar size={20} />
                                    <h2>My Leave Requests</h2>
                                </div>
                                <button className={styles['view-all-btn']}>View All</button>
                            </div>
                            <div className={styles['card-content']}>
                                <p className={styles['empty-text']}>No active leave requests.</p>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        </div>
    );
};

export default EmployeeDashboard;
